<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card class="ma-2 mb-4">
		<v-toolbar :color="color" dark>
			<v-toolbar-title style="white-space: normal; display: flex; align-items: center;">
				<v-icon class="mr-3" color="white">mail</v-icon>
				{{ header }}
			</v-toolbar-title>
			<v-spacer/>
		</v-toolbar>
		<add-offer-popup
			:legalFormMembership="legalFormMembership"
			v-if="placingOfferAllowed"/>

		<v-alert :value="offers !== null && offers.length === 0" type="info">
			{{ emptyWarning }}
		</v-alert>

		<v-list three-line v-if="offers !== null">
			<template v-for="(offer) in paginatedOffers">
				<v-divider v-bind:key="offer.id + 1000"></v-divider>
				<v-list-tile :key="offer.id" avatar
					:class="'list-item' + (isInformalOrNotQualified(offer) || isRejected(offer) || isNotFinanced(offer) ? ' shaded' : '')">
					<v-list-tile-avatar>
						<div v-if="warningCodes.includes(offer.offerCode)">
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-badge color="red" left v-on="on">
										<template v-slot:badge>
											<span>!</span>
										</template>
										<v-icon
											:color="getOfferStatusColor(offer)"
											:title="getOfferStatusMessage(offer)">
											{{getOfferStatusIcon(offer)}}
										</v-icon>
									</v-badge>
								</template>
							</v-tooltip>
						</div>
						<div v-else>
							<v-icon
								:color="getOfferIconColor(offer)"
								:title="getOfferIconTitle(offer)"
							>
								{{ isInformalOrNotQualified(offer) ? 'info' : getOfferStatusIcon(offer) }}
							</v-icon>
						</div>
					</v-list-tile-avatar>

					<v-list-tile-content>
						<v-list-tile-title v-html="getBidder(offer)" v-if="bidderNameVisible"
							style="font-size: 14px"></v-list-tile-title>
						<v-list-tile-title v-html="getTileTitle(offer)" style="font-size: 14px"></v-list-tile-title>
						<v-list-tile-sub-title v-html="getOfferCode(offer)"></v-list-tile-sub-title>
						<v-list-tile-action-text style="display: flex; align-items: center;">
							<span v-html="getOfferStatusMessage(offer)"></span>
							<egranty-icon-button v-if="offer.correctionDeadline"
								icon="info"
								:label="'Termin poprawy: ' + offer.correctionDeadline"
								class="custom-info-icon"
							/>
						</v-list-tile-action-text>
						<v-list-tile-action-text v-html="getEvaluationStats(offer)"
							v-if="showEvaluationStats && !isRejected(offer)"
							style="font-weight: bold"></v-list-tile-action-text>
					</v-list-tile-content>

					<v-list-tile-action v-if="showPrivillagesIcon && (offer.listOfUsersToGivePrivillages && offer.listOfUsersToGivePrivillages.length >0)">
						<egranty-icon-button
						icon="person"
						color="blue"
						label="Przekaż uprawnienia"
						for="my-contest-offer-list-view-confirm"
						id="my-contest-offer-list-view-confirm"
						@click="$emit('showDialogWithUsers',offer)"/>
					</v-list-tile-action>

					<v-list-tile-action v-else-if="isOfferEditionPossible(offer) && offer.offerCreator && roles.isSubBidder() && subbiderType === 'COWORKER' && offer.offerStatus === 'NEW'">
						<egranty-icon-button
						icon="person"
						color="blue"
						disabled
						label="Po otrzymaniu projektu oferty użytkownik konta nadrzędnego będzie mógł ją przekazać do edycji innej osobie"
						for="my-contest-offer-list-info"
						id="my-contest-offer-list-info"/>
					</v-list-tile-action>

					<v-list-tile-action v-else-if="offer.showInfoIconToParent">
						<egranty-icon-button
						icon="person"
						color="blue"
						disabled
						label="Przekazanie uprawnień do edycji będzie możliwe po przesłaniu projektu oferty przez jej autora"
						for="my-contest-offer-list-info"
						id="my-contest-offer-list-info"/>
					</v-list-tile-action>

					<v-list-tile-action >
						<egranty-icon-button
               				 	v-if="offer.usernameCanManage"
                				icon="info"
                				small
                				:label="showCanManageOfferUserText(offer)"
              		/>
					</v-list-tile-action>
				

					<v-list-tile-action v-if="editingVisible">
						<egranty-icon-button
							icon="edit"
							:color="color"
							label="Edycja"
							for="offers-list-edit"
							id="offers-list-edit"
							@click="editOffer(offer.id)" :disabled="!isOfferEditionPossible(offer)"/>
					</v-list-tile-action>

					<slot name="extraAction" v-bind:offer="offer"/>

					<v-list-tile-action>
						<egranty-icon-button icon="history" color="brown" label="Historia"
							@click="viewHistory(offer.id)"/>
					</v-list-tile-action>

					<v-list-tile-action>
						<egranty-icon-button
							icon="description"
							:color="color"
							label="Podgląd"
							for="offers-list-preview"
							:disabled="offer.offerStatus === 'AWAITING_CORRECTION' || offer.offerStatus === 'NEW'"
							id="offers-list-preview"
							@click="viewOffer(offer.id)"/>
					</v-list-tile-action>

					<v-list-tile-action v-if="roles.isBidder() || roles.isSubBidder()">
						<egranty-icon-button
							icon="delete"
							color="lightred"
							label="Usuń"
							for="offers-list-delete"
							id="offers-list-delete"
							:disabled="(offer.offerStatus !== 'NEW' || !isOfferEditionPossible(offer))"
							@click="deleteOffer(offer.id)"/>
					</v-list-tile-action>

					<v-list-tile-action v-if="isExpandable">
						<egranty-icon-button
							:icon="tileExpanded[offer.id] ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
							color="gray" :label="expandableAreaLabel"
							@click="expandTile(offer.id)"
							:disabled="expansionDisabled(offer)"/>
					</v-list-tile-action>
				</v-list-tile>

				<v-slide-y-transition :key="'more-' + offer.id" v-if="isExpandable">
					<v-card flat v-show="tileExpanded[offer.id]">
						<slot name="expandableArea" v-bind:offer="offer"/>
					</v-card>
				</v-slide-y-transition>
			</template>
		</v-list>
		<div class="text-xs-center">
			<v-pagination
				v-if="isPaginated"
				v-model="pagination.page"
				:length="length"
				:total-visible="7"
			></v-pagination>
		</div>
	</v-card>
</template>

<script>
	import {Dates} from "@/utils/Dates";
	import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";
	import AddOfferPopup from "./AddOfferPopup";
	import {Offer} from "@/api/generated/Offer";
	import {User} from "@/api/generated/User";

	export default {
		name: "OffersList",

		components: {AddOfferPopup, EgrantyIconButton},

		data () {
			return {
				tileExpanded: {},

				dialogsState: {
					rejectCauseDialogOpen: false,
					selectedOfferId: null,
				},

				pagination: {
					page: 1,
					offersPerPage: 10,
					sortBy: null
				},
				nonPaginatedOfferCodes: [],
				subbiderType: null,
			};
		},

		watch: {
			filteredOffers() {
				this.pagination.page = 1;
			}
		},

		computed: {
			length () {
				if (this.offers) {
					return Math.ceil(this.filteredOffers.length / this.pagination.offersPerPage);
				} else {
					return 1;
				}
			},
			offerCodes() {
				return this.filteredOffers.map(offer => offer.offerCode);
			},

			paginatedOffers() {
				let firstOfferIndex = (this.pagination.page - 1) * this.pagination.offersPerPage;
				return this.filteredOffers.slice(firstOfferIndex, Math.min(firstOfferIndex + this.pagination.offersPerPage, this.filteredOffers.length));
			},

			filteredOffers() {
        if (!this.offers) {
          return [];
        }
				if (!this.isExpandable) {
					return this.offers;
				}
				let offers = this.offers;
				if (this.search.countryId) {
					offers = offers.filter(offer => offer.countryId === this.search.countryId);
				}

				if (this.search.offerCode) {
					offers = offers.filter(offer => offer.offerCode.includes(this.search.offerCode));
				}

				if (this.search.evaluating) {
					offers = offers.filter(offer => {
						let contains = false;
						let fe = offer.formalEvaluations;
						let se = offer.substantiveEvaluations;
						let fie = offer.finalEvaluation;
						let ee = offer.expertEvaluations;
						fe.forEach(e => {
							let user = e.committeeUser.user.user;
							contains = contains | this.compareUser(user);
						});
						se.forEach(e => {
							let user = e.committeeUser.user.user;
							contains = contains | this.compareUser(user);
						});

						ee.forEach(e => {
							let user = e.contestUser.user;
							contains = contains | this.compareUser(user);
						});
						if (fie) {
							let user = fie.committeeUser.user.user;
							contains = contains | this.compareUser(user);
						}
						return contains;
					});
				}

				if (this.search.committeeId) {
					if (this.search.committeeId === -1) {
						offers = offers.filter(offer => offer.committeeId === null);
					} else {
						offers = offers.filter(offer => offer.committeeId === this.search.committeeId);
					}
				}
				if (offers) {
					offers.sort((a, b) => {
						return this.parseOfferOrdinalNumber(b.offerCode) - this.parseOfferOrdinalNumber(a.offerCode);
					});
				}
				return offers;
			},
		},

		props: {
			offers: {type: Array, default: () => []},
			notQualifiedOffersIds: {type: Array, default: () => []},
			contestId: String,
			contestStatus: {type: String, default: ""},
			header: String,
			emptyWarning: String,
			color: {type: String, default: "teal"},
			placingOfferAllowed: {type: Boolean, default: false},
			bidderNameVisible: {type: Boolean, default: false},
			editingVisible: {type: Boolean, default: false},
			showPrivillagesIcon: {type: Boolean, default: false},
			isExpandable: {type: Boolean, default: false},
			isPaginated: {type: Boolean, default: false},
			expandableAreaLabel: {type: String, default: "Rozwiń..."},
			legalFormMembership: Boolean,
			expansionDisabled: {
				type: Function, default: () => {
				},
			},
			inclusionStatuses: {
				type: Object, default: () => {
					return {
						agencyEvaluationSchemaIncluded: false,
						expertEvaluationSchemaIncluded: false,
						finalEvaluationSchemaIncluded: false,
						formalEvaluationSchemaIncluded: false,
						individualEvaluationSchemaIncluded: false,
					};
				},
			},
			showEvaluationStats: {type: Boolean, default: false},
			warningCodes: {type: Array, default: () => []},
			search: {
				type: Object,
				default: () => {
					return {};
				},
			},
		},

		mixins: [
			Dates,
		],

		created() {
			this.loadSubbiderType();
		},

		methods: {
			loadSubbiderType() {
				if (this.roles.isSubBidder()) {
					User.getUserSubbiderType(this,
						response => {
							this.subbiderType = response;
						}
					);
				}
			},

			showCanManageOfferUserText(offer){
      			return "Użytkownik " + offer.usernameCanManage + " aktualnie zarządza ofertą";
    		},
      isInformalOrNotQualified(offer) {
        return this.isInformal(offer) || this.notQualified(offer.id);
      },

      isInformal(offer) {
        if (!offer.formalEvaluations) {
          return false;
        }

        return offer.formalEvaluations.some(e => e.evaluationStatus === "FINISHED" && !e.passed);
      },

			notQualified (offerId) {
				return this.notQualifiedOffersIds.includes(offerId);
			},

			compareUser(user) {
				return (user.name.concat(" ").concat(user.surname)).toLowerCase().includes(this.search.evaluating.toLowerCase());
			},

			parseOfferOrdinalNumber (offerCode) {
				return offerCode.split("/")[2];
			},
			expandTile (offerId) {
				this.$set(this.tileExpanded, offerId, !this.tileExpanded[offerId]);
			},

			getBidder (offer) {
				return offer.mainBidder.polishName;
			},

			getTileTitle (offer) {
				return offer.offerData.title;
			},

			getOfferCode (offer) {
				return offer.offerCode;
			},

      getOfferIconColor(offer) {
        return this.isInformalOrNotQualified(offer) ? 'primary' : this.getOfferStatusColor(offer);
      },

      getOfferIconTitle(offer) {
        return this.isInformal(offer)
            ? 'Oferta odrzucona z powodów formalnych'
            : this.notQualified(offer.id)
                ? 'Oferta nie osiągnęła progu kwalifikacji'
                : this.getOfferStatusMessage(offer);
      },

			getOfferStatusIcon (offer) {
				if (this.editingVisible) {
					return !this.isOfferEditionPossible(offer) ? "lock" : "lock_open";
				} else {
					switch (offer.offerStatus) {
						case "SUBMITTED":
						case "RESERVED":
						case "NOT_FINANCED":
							return "check";
						case "REJECTED":
							return "block";
						case "FINANCED":
							return "star";
						case "APPROVED":
							return "stars";
						case "AWAITING_CORRECTION":
						case "POST_CORRECTION_MUTUAL":
						case "POST_CORRECTION_MAIN":
							return "build";
					}
				}
			},

			getOfferStatusMessage (offer) {
				if(offer.offerProcessed){
					return "Oferta opiniowana";
				}
				let statusMessage = this.getDefaultStatusMessage(offer);
				if(offer.offerProcessedForBidder){
					statusMessage = statusMessage + " (opiniowana)";
				}
				statusMessage = this.addCauseStatusToMessage(offer,statusMessage);
				return statusMessage;
			},

			getDefaultStatusMessage(offer){
				switch (offer.offerStatus) {
					case "NEW":
						return "Oferta w trakcie uzupełniania";
					case "AWAITING_MAIN_BIDDER_ACCEPTANCE":
						return "Oczekuje na akceptację";
					case "POST_CORRECTION_MAIN":
						return "Oczekuje na akceptację zmian";
					case "AWAITING_MUTUAL_BIDDERS_ACCEPTANCE":
						return "Oczekuje na akceptację współoferentów";
					case "POST_CORRECTION_MUTUAL":
						return "Oczekuje na akceptację współoferentów";
					case "SUBMITTED":
						return "Oferta wysłana";
					case "REJECTED":
						return "Oferta odrzucona";
					case "AWAITING_CORRECTION":
						return "Oferta oczekuje na poprawki";
					case "FINANCED":
						return "Oferta finansowana";
					case "NOT_FINANCED":
						return "Oferta niefinansowana";
					case "APPROVED":
						return "Oferta realizowana";
					case "RESERVED":
						return "Oferta rezerwowa";
				}
			},
			addCauseStatusToMessage(offer,statusMessage){
				switch (offer.offerStatus) {
					case "REJECTED":
						return statusMessage + ": " +  offer.rejectCause;
					case "AWAITING_CORRECTION":
						return statusMessage + ": " + offer.correctionCause;
				}
				return statusMessage;
			},

			getOfferStatusColor (offer) {
				switch (offer.offerStatus) {
					case "NEW":
						return "primary";
					case "AWAITING_MAIN_BIDDER_ACCEPTANCE":
						return "blue";
					case "AWAITING_MUTUAL_BIDDERS_ACCEPTANCE":
					case "POST_CORRECTION_MUTUAL":
					case "POST_CORRECTION_MAIN":
						return "blue";
					case "AWAITING_CORRECTION":
						return "amber";
					case "SUBMITTED":
					case "NOT_FINANCED":
						return "green";
					case "REJECTED":
						return "lightred";
					case "RESERVED":
					case "FINANCED":
						return "primary";
					case "APPROVED":
						return "primary";
				}
			},

			getEvaluationStats (offer) {
				let stats = [];
				if (this.inclusionStatuses.formalEvaluationSchemaIncluded) {
					stats.push(this.getMultipleEvaluationStats("F", offer.formalEvaluations));
				}
				if (this.inclusionStatuses.individualEvaluationSchemaIncluded) {
					stats.push(this.getMultipleEvaluationStats("M", offer.substantiveEvaluations));
				}
				if (this.inclusionStatuses.agencyEvaluationSchemaIncluded) {
					stats.push(this.getSingleEvaluationStats("P", offer.agencyEvaluation));
				}
				if (this.inclusionStatuses.expertEvaluationSchemaIncluded) {
					stats.push(this.getMultipleEvaluationStats("E", offer.expertEvaluations));
				}
        if (this.inclusionStatuses.finalEvaluationSchemaIncluded) {
          stats.push(this.getSingleEvaluationStats("K", offer.finalEvaluation));
        }
				return stats.length > 0 ? stats.join(", ") : "Formularze ocen nie zostały jeszcze załączone";
			},

			getSingleEvaluationStats (symbol, evaluation) {
				if (evaluation === null) return symbol + ": 0/0";
				let result = "";
				if (evaluation.finalEvaluationStatus !== undefined) {
					result = evaluation.finalEvaluationStatus === "FINISHED" ? symbol + ": 1/1" : symbol + ": 0/1";
				} else if (evaluation.agencyEvaluationStatus !== undefined) {
					result = evaluation.agencyEvaluationStatus === "FINISHED" ? symbol + ": 1/1" : symbol + ": 0/1";
				}
				return result;
			},

			getMultipleEvaluationStats (symbol, evaluationList) {
				let listLength = evaluationList.length;
				let finishedEvalLength = 0;
				if (listLength > 0) {
					finishedEvalLength = evaluationList[0].expertEvaluationStatus === undefined ?
						evaluationList.filter(e => e.evaluationStatus === "FINISHED").length :
						evaluationList.filter(e => e.expertEvaluationStatus === "FINISHED").length;
				}
				return symbol + ": " + finishedEvalLength + "/" + listLength;
			},

			editOffer (offerId) {
				this.$router.push("/app/contest/" + this.contestId + "/place-offer/" + offerId);
			},

			viewOffer (offerId) {
				this.$router.openInNewTab("/view/contest/" + this.contestId + "/offer/" + offerId);
			},

			viewHistory (offerId) {
				this.$router.push("/app/offer/" + offerId + "/history");
			},

			deleteOffer (offerId) {
				this.$confirm("Czy na pewno chcesz usunąć ofertę?", {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie oferty",
					width: 500
				})
					.then(res => {
						if (res) {
							Offer.delete(this, offerId, successResponse => {
									this.$emit("offer-removed", offerId);
									this.$messagesBus.$emit("success", "Oferta została pomyślnie usunięta", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć oferty", errorResponse);
								});
						}
					});
			},

			isRejected(offer) {
				return offer.offerStatus === "REJECTED";
			},

      isNotFinanced(offer) {
        return offer.offerStatus === "NOT_FINANCED";
      },

			isOfferEditionPossible(offer) {
					return offer.editAllowed;
			}
		},
	};
</script>

<style scoped>
	.v-toolbar >>> .v-toolbar__content {
		min-height: 64px !important;
		height: auto !important;
	}

	.theme--dark .v-list__tile__action-text {
		color: #fff;
	}

	.shaded {
		background-color: rgb(232, 232, 232);
	}

	.theme--dark .shaded {
		background-color: #606060 !important;
	}

	.custom-info-icon >>> .v-btn {
		width: 16px !important;
		height: 16px !important;
		min-width: 16px !important;
		padding: 0 !important;
		margin: 0 4px !important;
	}

	.custom-info-icon >>> .v-btn .v-icon {
		font-size: 16px !important;
	}
</style>
